<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>断点样式适配</h2>
      <p>三档统一断点：大屏 &gt; 1760px（默认）／中屏 ≤ 1760px／小屏 ≤ 1480px，拖拽窗口宽度查看递减效果</p>
    </div>

    <!-- 视口档位指示器 -->
    <div class="bp-viewport">
      <span class="bp-viewport__width">当前视口 {{ viewportWidth }}px</span>
      <span class="bp-viewport__tag" :class="bandClass">{{ bandText }}</span>
    </div>

    <!-- 三行简单列表：输入框 / 下拉框 / div 卡片 -->
    <div class="bp-list">
      <div class="bp-row">
        <span class="bp-label">输入框</span>
        <div class="bp-field bp-input">
          <el-input
            v-model="inputValue"
            placeholder="请输入内容"
            clearable
          />
        </div>
      </div>

      <div class="bp-row">
        <span class="bp-label">下拉框</span>
        <div class="bp-field bp-select">
          <el-select v-model="selectValue" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>

      <div class="bp-row">
        <span class="bp-label">div 卡片</span>
        <div class="bp-field">
          <div class="bp-card">
            <div class="bp-card__title">断点卡片</div>
            <div class="bp-card__desc">随视口宽度逐档递减：宽度每档 -20px、字号每档 -1px、按钮每档 -2px</div>
            <el-button type="primary" size="mini" round class="bp-btn">查看</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PcDemoBreakpoints',
  data() {
    return {
      viewportWidth: window.innerWidth,
      inputValue: '',
      selectValue: '',
      options: [
        { value: '1', label: '选项一' },
        { value: '2', label: '选项二' },
        { value: '3', label: '选项三' }
      ]
    }
  },
  computed: {
    bandText() {
      if (this.viewportWidth > 1760) return '大屏档 > 1760px'
      if (this.viewportWidth > 1480) return '中屏档 ≤ 1760px'
      return '小屏档 ≤ 1480px'
    },
    bandClass() {
      if (this.viewportWidth > 1760) return 'is-large'
      if (this.viewportWidth > 1480) return 'is-middle'
      return 'is-small'
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.viewportWidth = window.innerWidth
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/breakpoints.scss';

.bp-viewport {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: var(--spacing-xl);

  &__width {
    font-size: var(--font-size-md);
    color: var(--color-text-regular);
  }

  &__tag {
    padding: 4px 12px;
    border-radius: 999px;
    font-size: var(--font-size-xs);
    line-height: 1;
    border: 1px solid var(--border-color-base);

    &.is-large {
      color: var(--color-success);
      border-color: var(--color-success);
      background: rgba(103, 194, 58, 0.1);
    }

    &.is-middle {
      color: var(--color-warning);
      border-color: var(--color-warning);
      background: rgba(230, 162, 60, 0.1);
    }

    &.is-small {
      color: var(--color-primary);
      border-color: var(--color-primary);
      background: var(--color-primary-light);
    }
  }
}

.bp-list {
  // 列表整体宽度随视口逐档递减（980 → 960 → 940）
  @include bp-width(980px);
  max-width: 100%;
  margin: 0 auto;
  padding: var(--spacing-lg);
  background: var(--bg-color-card);
  border: 1px solid var(--border-color-base);
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-md);
  box-sizing: border-box;

  .bp-row {
    display: flex;
    align-items: center;
    margin-bottom: var(--spacing-lg);

    &:last-child {
      margin-bottom: 0;
    }

    .bp-label {
      @include bp-font-size(14px);
      flex-shrink: 0;
      width: 72px;
      color: var(--color-text-primary);
    }

    .bp-field {
      flex: 1;
      min-width: 0;
    }

    .bp-input {
      width: 100%;

      ::v-deep .el-input__inner {
        @include bp-font-size(14px);
      }
    }

    .bp-select {
      width: 100%;

      ::v-deep .el-input__inner {
        @include bp-font-size(14px);
      }
    }

    .bp-card {
      @include bp-width(620px);
      max-width: 100%;
      box-sizing: border-box;
      padding: var(--spacing-md);
      border: 1px solid var(--border-color-base);
      border-radius: var(--border-radius-md);
      background: var(--bg-color-white);
      transition: width 0.2s ease;

      &__title {
        @include bp-font-size(16px);
        margin-bottom: 6px;
        color: var(--color-text-primary);
        font-weight: 600;
      }

      &__desc {
        @include bp-font-size(13px);
        @include bp-line-height(20px);
        margin-bottom: 10px;
        color: var(--color-text-regular);
      }

      .bp-btn {
        @include bp-button-size(26px);
      }
    }
  }
}
</style>
